import { RootState } from "store";

export const getAnalyticsFilters = (state: RootState) => state.analytics;

export const getAnalyticsComparingFilters = (state: RootState) =>
  state.analytics.comparing;

export const getAnalyticsLocationsFilters = (state: RootState) =>
  state.analytics.location;
